import React from 'react';
import './BankDetailsComponent.styles.scss';

const BankDetailsComponent = ({ className, bankDetails }) => {
  return (
    <div className={`${className}`}>
      <div className="common_card admin_company_bank p-3 h-100">
        <div className="">
          <h6 className="pt-1"><strong>Bank Details</strong></h6>
        </div>
        <ul>
          <li>
            <h5>{bankDetails.upi || 'n/a'}</h5>
            <span>UPI ID</span>
          </li>
          <li>
            <h5>{bankDetails.bankname || 'n/a'}</h5>
            <span>Bank Name</span>
          </li>
          <li>
            <h5>{bankDetails.accountnumber || 'n/a'}</h5>
            <span>Account Number</span>
          </li>
          <li>
            <h5>{bankDetails.ifsc || 'n/a'}</h5>
            <span>IFSC Code</span>
          </li>
        </ul>

      </div>
    </div>
  );
};

export default BankDetailsComponent;
